import React, { useState, useEffect, useCallback } from "react";
import { Container, Grid } from "./styles";
import Card from "./card";
import HypervisorSummary from "components/hypervisorSummary";
import InstanceSummary from "./instanceSummary";
import { useHeader } from "components/header/store";
import { hypervisorAPI, userAPI } from "api";
import { getTaskData } from "api/taskStatus";

const DashboardPage = () => {
  const domain_admin = sessionStorage.getItem("domain_admin") === "true";
  const ou_admin = sessionStorage.getItem("ou_admin") === "true";

  const { setTitle, setButtons } = useHeader();

  const [instances, setInstances] = useState([]);
  const [summaryInstances, setSummaryInstances] = useState(null);
  const [summaryHypervisor, setSummaryHypervisor] = useState(null);

  const GetVDI = useCallback(async () => {
    const data = await getTaskData(userAPI.dashboard);

    const nextInstances = data?.result?.data?.instances ?? [];
    const nextSummaryInstances = data?.result?.data?.summary ?? null;

    setInstances(nextInstances);
    setSummaryInstances(nextSummaryInstances);
  }, []);

  useEffect(() => {
    setTitle("DASHBOARD");
    setButtons(
      <button
        onClick={GetVDI}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "1.2rem",
          display: "flex",
          alignItems: "center",
          color: "#475569",
        }}
        title="새로고침"
      >
        ↻
      </button>
    );
  }, [setTitle, setButtons, GetVDI]);

  useEffect(() => {
    (async () => {
      if (!summaryHypervisor) {
        try {
          const summaryData = await hypervisorAPI.getHypervisorSummary();
          setSummaryHypervisor(summaryData?.data?.data);
        } catch (error) {
          console.error("Failed to load hypervisor summary", error);
        }
      }
    })();

    GetVDI();
  }, [GetVDI, summaryHypervisor]);

  return (
    <Container>
      {domain_admin && <HypervisorSummary summary={summaryHypervisor} />}

      {ou_admin && summaryInstances && (
        <InstanceSummary data={summaryInstances} />
      )}
      <Grid>
        {instances.map((data, index) => (
          <React.Fragment key={index}>
            <Card data={data} />
          </React.Fragment>
        ))}
      </Grid>
    </Container>
  );
};

export default DashboardPage;
